import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ValidationService } from '@core/services/api/http/validation.service';
import { RoutePaths } from '@global/routePaths';
import { ModalController } from '@ionic/angular';
import { FlowAbstractPage } from '@pages/flow-abstract/flow-abstract';

@Component({
  selector: 'qb-de-client-verification-modal',
  templateUrl: './client-verification-modal.component.html',
  styleUrls: ['./client-verification-modal.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QbClientVerificationModalComponent extends FlowAbstractPage {
  protected previousRoute: string;
  protected nextRoute: string = RoutePaths.NEW_QUOTATION.CONTRACT.POLICYHOLDER_DATA.route;
  protected analyticStepName: string;
  protected analyticFlowName: string;
  protected analyticStepNumber: Record<string, string>;
  protected initForm(): void {
    throw new Error('Method not implemented.');
  }
  protected saveStepData(): void {
    throw new Error('Method not implemented.');
  }
  protected readonly validationService: ValidationService = inject(ValidationService);

  constructor(private readonly modalCTR: ModalController) {
    super();
    this.analyticsService.sendPopupView('verification data');
  }

  onClose(): void {
    this.modalCTR.dismiss();
  }

  goData(): void {
    this.navigateTo(this.nextRoute);
    this.onClose();
  }
}
